import * as React from "react"

import { GlobalState } from "../../../../../../store"
import { fetchConcept, fetchItem } from "../../../../../resources/thunks"
import { useAppDispatch, useAppSelector } from "../../../../../../hooks"
import {
    itemSelector,
    conceptSelector,
} from "../../../../../resources/adapters"

import Button from "../Button"
import UnavailableLink from "../UnavailableLink"
import { IGlobalActionsController } from "../../../../../../global"

declare let globalActionsController: IGlobalActionsController

interface Props {
    attributes: Record<string, string>
    label: string
    itemId: number
    childConceptId?: number
}

export const CreateChildItem = ({
    attributes,
    childConceptId,
    itemId,
    label,
}: Props): JSX.Element => {
    const dispatch = useAppDispatch()
    const resources = useAppSelector((state: GlobalState) => state.resources)
    const item = itemSelector.selectById(resources, itemId)

    const concept = !!childConceptId
        ? conceptSelector.selectById(resources, childConceptId)
        : undefined

    const isConceptFetched = !!childConceptId && !concept

    React.useEffect(() => {
        if (!item) {
            dispatch(fetchItem(itemId))
        }

        if (isConceptFetched) {
            dispatch(fetchConcept(childConceptId))
        }
    }, [])

    const shouldUseConceptId = !!childConceptId && !!concept?.doesExist

    if (!item || isConceptFetched) {
        return (
            <UnavailableLink
                attributes={attributes}
                label={label}
                isLoading={true}
            />
        )
    } else if (
        item.doesExist &&
        // only accept the childConceptId if it's valid
        (shouldUseConceptId ||
            // or if it doesn't exist
            (!childConceptId && !shouldUseConceptId))
    ) {
        // If the childListId is specified, we use that otherwise we use null
        // see CreateChildItemLink.cs
        // javascript:globalActionsController.createChildItem(itemId,null);
        // javascript:globalActionsController.createChildItem(itemId,childId);
        // this will open the CNCI with a specified concept selected

        // only use the provided childConceptId if the concept exists
        const conceptId = shouldUseConceptId
            ? concept.id
            : item.concept?.id ?? null

        const onClick = (event: React.MouseEvent<HTMLButtonElement>): void => {
            event.stopPropagation()
            globalActionsController.createChildItem(item.id, conceptId)
        }

        return (
            <Button attributes={attributes} label={label} onClick={onClick} />
        )
    }

    return <UnavailableLink attributes={attributes} label={label} />
}

export default CreateChildItem
